<template>
  <!-- 患者検索 -->
  <div id="AppPatientSearchSleepResult">
    <!-- 検索結果 -->
    <div class="columns">
      <div class="column is-two-thirds" style="text-align: left">
        <b-button
          class="button is-primary has-text-centered"
          icon-left="google-maps"
          :disabled="!checkedRows.length"
          native-type="button"
          position="is-right"
          v-on:click="doShowGoogleMapChecked"
          >地図表示</b-button
        >
      </div>
      <div class="column is-one-third">
        <b-field
          horizontal
          label="患者検索結果"
          style="float: right; white-space: nowrap"
        >
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div>
      <b-table
        :data="searchResult"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :pagination-size="paginationSize"
        :backend-sorting="true"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        detailed
        @details-open="getPatientDetail"
        :opened-detailed="openedDetails"
        detail-key="patientCode"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :default-sort-direction="sortOrder"
        :default-sort="sortItem"
        @sort="sort"
        @page-change="changePage"
      >
        <template v-if="props.row" slot-scope="props">
          <b-table-column field="caution" centered>
            <div v-if="props.row.caution">
              <b-icon icon="account-alert"> </b-icon>
            </div>
            <div v-if="props.row.followUpCall">
              <b-icon icon="volume-high" type="is-info"> </b-icon>
            </div>
          </b-table-column>

          <b-table-column
            field="patientName"
            label="患者名（患者コード）"
            sortable
            centered
          >
            {{ props.row.patientName + "（" + props.row.patientCode + "）" }}
          </b-table-column>

          <b-table-column
            field="patientNameKana"
            label="患者名（カナ）"
            sortable
            centered
          >
            {{
              convFullHalfWidthCharacterKana(props.row.patientNameKana, "full")
            }}
          </b-table-column>

          <b-table-column
            field="patientPhone"
            label="電話番号"
            sortable
            centered
          >
            {{ props.row.patientPhone }}
          </b-table-column>

          <b-table-column
            label="営業担当者"
            sortable
            centered
          >
            {{ props.row.staffName }}
          </b-table-column>

          <b-table-column
            field="hospitalNames"
            label="医療機関"
            sortable
            centered
          >
            <div
              v-for="(hospitalName, index) in getHospitalNames(props.row)"
              :key="'productDetail_' + index"
            >
              {{ hospitalName }}
            </div>
          </b-table-column>

          <b-table-column field="officeName" label="支店" sortable centered>
            {{ getOfficeNames(props.row) }}
          </b-table-column>

          <!-- CO連携（要件、サポート時期未定）
          <b-table-column field="isCo" label="CO/EA" sortable centered>
            <span v-if="props.row.isCo">{{ props.row.isCo | coEaFilter }}</span>
          </b-table-column>
          -->

          <b-table-column
            field="isSupplyLeaked"
            label="供給漏れ"
            sortable
            centered
            :class="getSupplyLeakedClass(props.row)"
          >
            {{ props.row.isSupplyLeaked | existenceFilter }}
          </b-table-column>

          <b-table-column
            field="referenceMonth"
            label="交換対象月"
            sortable
            centered
            :class="getReferenceMonthClass(props.row)"
          >
            {{ getReferenceMonth(props.row) }}
          </b-table-column>

          <b-table-column
            field="dreamMapper"
            label="ﾄﾞﾘｰﾑﾏｯﾊﾟｰ"
            sortable
            centered
          >
            <b-icon v-if="props.row.dreamMapper" icon="check"></b-icon>
          </b-table-column>

          <b-table-column field="isDeleted" label="状態" sortable centered>
            {{ props.row.isDeleted | deletedFilter }}
          </b-table-column>

          <b-table-column field="files" label="添付" centered>
            <b-button
              v-if="props.row.files.length"
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-paperclip"
              native-type="button"
              @click="showFiles(props.row.files)"
            ></b-button>
          </b-table-column>

          <b-table-column field="configuration" label="対応記録" centered>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="pencil"
              native-type="button"
              @click="gotoAppUrgentList(props.row)"
            ></b-button>
          </b-table-column>

          <b-table-column label="詳細" centered>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-cog"
              native-type="button"
              @click="refDetail(props.row)"
            ></b-button>
          </b-table-column>
        </template>

        <!-- 詳細 -->
        <template slot="detail" slot-scope="props">
          <!-- 機器情報 -->
          <table style="table-layout: fixed">
            <template
              v-for="(prodItem, prodItemIndex) in props.row.productDetails"
            >
              <div
                v-if="prodItem.attachedEquipments"
                v-bind:key="'div_prodItem1_' + prodItemIndex"
              >
                <tr v-bind:key="'prodItem1_' + prodItemIndex">
                  <th
                    style="width: 150px"
                    :rowspan="
                      4 +
                      prodItem.attachedEquipments.length * 2 +
                      expendablesRowNum(prodItem.expendables)
                    "
                  >
                    機器情報 {{ prodItemIndex + 1 }}
                  </th>
                  <th style="width: 150px">機器名</th>
                  <td colspan="2">
                    {{ prodItem.productName }} ({{ prodItem.productCode }})
                  </td>
                </tr>
                <tr v-bind:key="'prodItem2_' + prodItemIndex">
                  <th>シリアルNo.</th>
                  <td colspan="2">{{ prodItem.serialNumber }}</td>
                </tr>
                <tr v-bind:key="'prodItem3_' + prodItemIndex">
                  <th>医療機関名</th>
                  <td colspan="2">
                    {{ prodItem.hospitalName }} ({{ prodItem.hospitalCode }})
                  </td>
                </tr>
                <tr v-bind:key="'prodItem4_' + prodItemIndex">
                  <th>点検期間</th>
                  <td colspan="2">{{ prodItem.inspectionSpan }}ヶ月</td>
                </tr>

                <!-- 付属機器情報 -->
                <template
                  v-for="(
                    attachedEquipment, attacheIndex
                  ) in prodItem.attachedEquipments"
                >
                  <tr
                    v-bind:key="
                      'prodItem1_' + prodItemIndex + 'attachement_' + attacheIndex
                    "
                  >
                    <th style="width: 150px" rowspan="2">
                      付属機器情報 {{ attacheIndex + 1 }}
                    </th>
                    <th style="width: 150px">機器名</th>
                    <td>
                      {{ attachedEquipment.productName }} ({{
                        attachedEquipment.productCode
                      }})
                    </td>
                  </tr>
                  <tr
                    v-bind:key="
                      'prodItem2_' + prodItemIndex + 'attachement_' + attacheIndex
                    "
                  >
                    <th>シリアルNo.</th>
                    <td>{{ attachedEquipment.serialNumber }}</td>
                  </tr>
                </template>

                <!-- 消耗品 -->
                <template v-for="(expendable, index) in prodItem.expendables">
                  <!-- 1行目 -->
                  <tr
                    v-if="
                      expendable.type == expendableTypes.mask.code ||
                      expendable.type == expendableTypes.chamber.code
                    "
                    v-bind:key="
                      'prodItem1_' + prodItemIndex + 'expendable_' + index
                    "
                  >
                    <th
                      style="width: 150px"
                      :rowspan="
                        expendable.type == expendableTypes.mask.code ? 3 : 2
                      "
                    >
                      {{ expendable.type | expendableFilter }}
                    </th>
                    <th style="width: 150px">品目コード</th>
                    <td>
                      {{ expendable.productCode }}
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-bind:key="
                      'prodItem2_' + prodItemIndex + 'expendable_' + index
                    "
                  >
                    <th style="width: 150px">
                      {{ expendable.type | expendableFilter }}
                    </th>
                    <th style="width: 150px">チューブタイプ</th>
                    <td>
                      {{ expendable.productName }}
                    </td>
                  </tr>

                  <!-- 2行目 -->
                  <tr
                    v-if="
                      expendable.type == expendableTypes.mask.code ||
                      expendable.type == expendableTypes.chamber.code
                    "
                    v-bind:key="
                      'prodItem3_' + prodItemIndex + 'expendable_' + index
                    "
                  >
                    <th>品目名</th>
                    <td>{{ expendable.productName }}</td>
                  </tr>

                  <!-- 3行目 -->
                  <tr
                    v-if="expendable.type == expendableTypes.mask.code"
                    v-bind:key="
                      'prodItem4_' + prodItemIndex + 'expendable_' + index
                    "
                  >
                    <th>サイズ</th>
                    <td>{{ expendable.size }}</td>
                  </tr>
                </template>
                <tr></tr>
              </div>
            </template>

            <tr></tr>
          </table>
        </template>
      </b-table>
    </div>

    <googleMap-form
      v-model="isShowGoogleMap"
      v-bind:marker="addressList"
    ></googleMap-form>

    <!-- 添付一覧 -->
    <files-modal
      v-model="isShowFiles"
      :files="selectedFiles"
      @download-file="downloadFile($event)"
    />
  </div>
</template>

<script>
import Files from "./common/Files.vue";
import MapForm from "../components/common/Map.vue";
import orderBy from "lodash/orderBy";
import * as item from "../utils/item";

export default {
  components: {
    "googleMap-form": MapForm,
    "files-modal": Files,
  },

  props: ["value", "searchConditions"],

  name: "AppPatientSearchSleepResult",

  methods: {
    doShowGoogleMapChecked: function () {
      const address = [];
      for (const selected in this.checkedRows) {
        const target = {
          address: this.checkedRows[selected].address,
          name: this.checkedRows[selected].patientName,
          patientZipCode: this.checkedRows[selected].postCode,
        };
        address.push(target);
      }
      this.doShowGoogleMap(address);
    },

    doShowGoogleMap: function (address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },

    getSupplyLeakedClass: function (row) {
      const supplyLeakedClass = row.isSupplyLeaked ? "has-text-danger" : "";
      return supplyLeakedClass;
    },

    getReferenceMonthClass: function (row) {
      const referenceMonthClass = row.referenceMonth ? "has-text-danger" : "";
      return referenceMonthClass;
    },

    getReferenceMonth: function (row) {
      let referenceMonth = "";
      if (row.referenceMonth) {
        const referenceMonthDate = new Date(row.referenceMonth);
        referenceMonth = (referenceMonthDate.getMonth() + 1) + "月";
      }
      return referenceMonth;
    },

    showFiles: function (files) {
      this.selectedFiles = files;
      this.isShowFiles = true;
    },

    gotoAppUrgentList: function (row) {
      this.$router.push({
        name: "AppUrgentList",
        params: {
          patientCode: row.patientCode,
        },
      });
    },

    refDetail: function (row) {
      this.$router.push({
        name: "AppPatientDetailSleep",
        params: {
          code: row.patientCode,
          searchConditions: this.searchConditions,
        },
      });
    },

    downloadFile: function (file) {
      this.targetFile = file;
      this.downloadS3ApiCall(
        this.getPatientFile,
        this.getPatientFileError,
        this.$store.state.subSystem
      );
      return;
    },

    getPatientFile: function (client) {
      const res = client.apis.apiPatient.getPatientFileGET({
        id: this.targetFile.id,
      });
      this.targetFile = null;
      return res;
    },

    getPatientFileError: function (result) {
      this.showErrorMessage(result);
      return;
    },

    getHospitalNames: function (patient) {
      // 重複除外
      let codes = [];
      let names = [];
      for (const productDetail of patient.productDetails) {
        const code = productDetail.hospitalCode;
        const exists = codes.includes(code);
        if (!exists) {
          codes.push(code);
          names.push(productDetail.hospitalName);
        }
      }

      return names;
    },

    getOfficeNames: function (patient) {
      // 重複除外
      const codes = [];
      for (const productDetail of patient.productDetails) {
        const code = productDetail.officeCode;
        const exists = codes.includes(code);
        if (!exists) {
          codes.push(code);
        }
      }

      // 名称取得
      const names = [];
      for (const code of codes) {
        const refOffice = this.officeMaster.find(
          (elem) => elem.officeCode == code
        );
        if (refOffice) {
          names.push(refOffice.officeName);
        } else {
          names.push("");
        }
      }

      // 名称結合
      const res = names.join("\n");

      return res;
    },

    expendablesRowNum(expendables) {
      let rowNum = 0;

      for (const expendable of expendables) {
        switch (expendable.type) {
          case this.expendableTypes.mask.code:
            rowNum += 3;
            break;
          case this.expendableTypes.chamber.code:
            rowNum += 2;
            break;
          case this.expendableTypes.hose.code:
            rowNum += 1;
            break;
        }
      }

      return rowNum;
    },

    changePage: async function (page) {
      this.checkedRows = [];
      this.$emit("search");
      return;
    },

    sort: async function (field, order) {
      this.sortItem = field;
      this.sortOrder = order;
      this.$emit("search");
      return;
    },

    getPatientDetail: function (row, index) {
      // 詳細部分を取得する
      this.searchConditions.productDetail = true;
      this.searchConditions.patientDetail = row.patientCode;
      this.$emit("search");

      return;
    },
  },
  data() {
    const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    return {
      officeMaster,
      searchResult: [],
      checkedRows: [],
      addressList: [],
      isShowGoogleMap: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      sortItem: "patientName",
      sortOrder: "asc",
      currentPage: 1,
      perPage: 10,
      selectedFiles: null,
      isShowFiles: false,
      expendableTypes: item.EXPENDABLE_TYPE_MAP,
      targetFile: null,
      openedDetails: [],
    };
  },
  filters: {},
  computed: {},
  watch: {
    value: function () {
      if (!this.searchConditions.productDetail) {
        this.openedDetails.splice(0);
      }
      this.searchConditions.productDetail = false;
      this.searchConditions.patientDetail = "";

      this.searchResult = JSON.parse(JSON.stringify(this.value));
      for (const row of this.searchResult) {
        if (!row) {
          continue;
        }
        row.productDetails = orderBy(row.productDetails, "hospitalName", "asc");
        let hospitalNames = "";
        for (const productDetail of row.productDetails) {
          hospitalNames += productDetail.hospitalName;
        }
        row.hospitalNames = hospitalNames;
      }
      return;
    },

    perPage: function () {
      this.$emit("search");
      return;
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientSearchSleepResult.vue